// Nosto

const handleNostoButton = (el) => {
  if (!el) return

  const nosto_element = el.closest('.nosto_element')
  const id = nosto_element.getAttribute("id")

  nosto_element.querySelectorAll('.card-slider-button').forEach(item => {
    item.setAttribute('aria-controls', id)
  })
}

const handleNostoSlider = (el) => {
  if (!el) return

  const config = { attributes: true }
  const slides = el.querySelectorAll('.card-slider__slide, .pdct-card')

  slides.forEach(item => {
    if (!item) return

    const observer = new MutationObserver(() => {
      observer.disconnect()
      item.setAttribute('role', 'listitem')
      item.removeAttribute('aria-hidden')
      item.removeAttribute('tabindex')
    })

    observer.observe(item, config)
  })
}

waitForElement('.js-pdp-product-recommendations .nosto-slider .card-slider-button').then(el => handleNostoButton(el))
waitForElement('.js-pdp-product-recommendations .nosto-carousel .card-slider-button').then(el => handleNostoButton(el))
waitForElement('.js-pdp-product-recommendations .nosto-carousel ~ .card-slider-buttons .card-slider-button').then(el => handleNostoButton(el))
waitForElement('.js-pdp-product-recommendations .nosto-slider').then(el => handleNostoSlider(el))
waitForElement('.js-pdp-product-recommendations .nosto-carousel').then(el => handleNostoSlider(el))